import { Stack, Typography } from '@mui/material';
import { IconCalendar, IconClock, IconCompanies } from 'assets/img';
import { DateTime } from 'luxon';
import { PopoverTwoColumnsInfoRow } from 'redesign/popover-two-column-table/popover-two-columns';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import { AvailabilityParsedItem } from '../availability-calendar.types';
import { AvailabilityTypeChip } from '../components/avialability-type-chip';

export const useGetPopoverInfoRows = (
  data: AvailabilityParsedItem[]
): PopoverTwoColumnsInfoRow[][] => {
  const { t } = useTranslation('all-platforms-common');

  return useMemo(
    () =>
      data.map((item) => {
        const rows: PopoverTwoColumnsInfoRow[] = [];

        const startDate = DateTime.fromISO(item.utcStartDateTime).toLocal();
        let workRowLabel: string;
        if (item.type === 'available') {
          workRowLabel = t('availability_page.worker_available');
        } else if (item.workName == null) {
          workRowLabel = t('availability_page.worker_busy');
        } else {
          workRowLabel = item.workName;
        }
        rows.push({
          label: workRowLabel,
          labelVariant: 'h3',
          value: <AvailabilityTypeChip type={item.type} />,
        });
        if (item.companyName) {
          rows.push({
            label: t('availability_page.company'),
            labelIcon: <IconCompanies />,
            value: item.companyName,
          });
        }

        rows.push({
          label: 'Datum',
          labelIcon: <IconCalendar />,
          value: startDate.toFormat('d LLL'),
        });

        let range: string;
        const from = DateTime.fromISO(item.utcStartDateTime).toLocal();
        const to = DateTime.fromISO(item.utcEndDateTime).toLocal();
        if (from.hour === 0 && from.minute === 0 && to.hour === 23 && to.minute === 59) {
          range = `Hele dag`;
        } else {
          range = `${from.toFormat('HH:mm')}–${to.toFormat('HH:mm')}`;
        }

        rows.push({
          label: 'Tijd',
          labelIcon: <IconClock />,
          value: (
            <Stack spacing={0.5}>
              <Typography variant="body1" fontWeight={600}>
                {range}
              </Typography>
            </Stack>
          ),
        });

        return rows;
      }),
    [data]
  );
};
